const MutationMap = new Map();

const observer = new MutationObserver(mutations => {
  for (const mutation of mutations) {
    if (mutation.type === "childList") {
      if (mutation.addedNodes.length) {
        for (const node of mutation.addedNodes) {
          MutationMap.forEach((ConstructorName, selector) => {
            if (node.nodeType === 1) {
              init(node, selector, ConstructorName);
            }
          });
        }
      }
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

const init = (rootElement, selector, ConstructorName) => {
  rootElement.querySelectorAll(selector)?.forEach(element => {
    // console.log(selector, ConstructorName.prototype.constructor.name, "init");
    new ConstructorName(element);
  })
}

const connect = (selector, ConstructorName) => {
  MutationMap.set(selector, ConstructorName);
  init(document, selector, ConstructorName);
}

export {connect};
